import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=12d1dd54&scoped=true&"
import script from "./Receiving.vue?vue&type=script&lang=js&"
export * from "./Receiving.vue?vue&type=script&lang=js&"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=12d1dd54&prod&lang=css&"
import style1 from "./Receiving.vue?vue&type=style&index=1&id=12d1dd54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1dd54",
  null
  
)

export default component.exports